// extracted by mini-css-extract-plugin
export default {"p":"bea833b0ab _72ff55bc85 _5345977126","clr":"_27b9cb5d50","dls":"_8668b71153"};